export const AuthActionType = {
  SET_USER: '@set_user',
};

export const ToastActionType = {
  HIDE_TOAST: 'HIDE_TOAST',
  SHOW_TOAST: 'SHOW_TOAST',
};

export const PermissionActionType = {
  SET_PERMISSIONS: 'SET_PERMISSIONS',
};

export const FilterValuesType = {
  SET_COMMON_FILTERS: 'SET_COMMON_FILTERS',
  SET_DEFAULT_RAW_SCREEN_FILTERS: 'SET_DEFAULT_RAW_SCREEN_FILTERS',
  REMOVE_DEFAULT_RAW_SCREEN_FILTERS: 'REMOVE_DEFAULT_RAW_SCREEN_FILTERS',
};

export const TriggerUpdateTableDataType = {
  TRIGGER: 'TRIGGER',
};
